module.exports = __webpack_public_path__ + "img/missing_soap.46327e1f.svg";